import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';

import {
  ActivityFormatService, AgeGroupService, ArrayService, AuthService, ITPerformanceService,
  ChurchService, DatabaseService, DocumentService, FestivalUserService 
} from '../../../core/services';

import { PageClass } from '../../../core/classes/page';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-report-viewer',
  templateUrl: './report-viewer.component.html',
  styleUrls: ['./report-viewer.component.less', '../../../core/styles/common.less']
})

export class ReportViewerComponent extends PageClass implements OnInit {

  reportId: string;
  page: string;
  srcUrl: string;

  constructor(
    protected activityFormatService: ActivityFormatService,
    protected itPerformanceService: ITPerformanceService,
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected documentService: DocumentService,
    protected modalController: ModalController,
    private route: ActivatedRoute,
    private router: Router,
    protected festivalUserService: FestivalUserService,
    protected alertController: AlertController) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    // Filter.Church
    if (!!this.currentUser && (this.currentUser.isReportViewer || this.currentUser.isAdmin)) {
      this.route.params.subscribe((params: Params) => { 
				this.reportId = params['reportid'];
        this.page = params['page'];

        this.loadReport();
			});
    } else {
      this.router.navigate(['/']);
    }
  }

  public loadReport = async (): Promise<void> => {

    var reportUrl = `https://datastudio.google.com/embed/reporting/${this.reportId}/page/${this.page}`;

    var params = {
      "ds20.serviceyear": environment.serviceYear,
      "ds20.church": this.currentUser?.church?.reference.id
    };

    var paramsAsString = JSON.stringify(params);
    var encodedParams = encodeURIComponent(paramsAsString);
    reportUrl = `${reportUrl}?params=${encodedParams}`;
    this.srcUrl = reportUrl;
  } 

  doRefresh = async (event: any) => {
    await this.loadData();
    event.target.complete();
  }

  showErrorMessage = async (header: string, errorMessage: string) => {
    const alert = await this.alertController.create({
      header: header,
      message: errorMessage,
      buttons: ['OK'],
    });

    alert.onDidDismiss().then(() => { 
    });

    await alert.present();
  }
}
